import { Injectable } from "@angular/core";
import { Globals } from "../globals";
import { HttpInterceptor } from "../interceptors/http-interceptor.service";
import { Observable } from "rxjs/Observable";
import { Response } from "@angular/http";
import { GeneralService } from "./general.service";
import { PermisoService } from "./permiso.service";
import { ArchivoPropuesta } from "../interfaces/archivo-propuesta";

@Injectable()
export class PropuestasService {
  constructor(
    private globals: Globals,
    private http: HttpInterceptor,
    private general: GeneralService,
    private permisoService: PermisoService
  ) { }

  /* FLUJO DE ESTADOS DE PROPUESTA */
  getFlujos(
    paginado: any = {
      page: 0,
      pageSize: 10,
    },
    orden: any = {
      sort: "",
      order: "",
    },
    filtros: any = {
      generico: "",
      tipo: "",
    }
  ): Observable<any> {
    let model = {};
    model['idCliente'] = localStorage.getItem('idCliente');
    return this.http
      .post(
        this.general.webserver + 'apiFlujoTrabajo/getFlujos',
        JSON.stringify({
          idCliente: localStorage.getItem("idCliente"),
          paginado: paginado,
          orden: orden,
          filtros: filtros,
        })
      ).map(
        (respuesta: Response) => respuesta.json());
  }

  crearFlujo(model: any): Observable<any> {
    return this.http
      .post(
        this.general.webserver + 'apiFlujoTrabajo/crearFlujo',
        JSON.stringify({
          idCliente: localStorage.getItem('idCliente'),
          flujo: model
        })
      ).map(
        (respuesta: Response) => respuesta.json());
  }

  editarFlujo(model: any): Observable<any> {
    return this.http
      .post(
        this.general.webserver + 'apiFlujoTrabajo/editarFlujo',
        JSON.stringify({
          idCliente: localStorage.getItem('idCliente'),
          flujo: model
        })
      ).map(
        (respuesta: Response) => respuesta.json());
  }

  /* FIN DE FLUJO DE ESTADOS DE PROPUESTA*/

  /** cursos*/
    getCursos(model): Observable<any> {
      model['idCliente'] = localStorage.getItem('idCliente');
      return this.http
        .post(
          this.general.webserver + 'apiCursos/GetCursos',
          model
        ).map(
          (respuesta: Response) => respuesta.json());
    }

  /* ESTADOS */
  getEstadosPropuestas(model): Observable<any> {
    model['idCliente'] = localStorage.getItem('idCliente');
    return this.http
      .post(
        this.general.webserver + 'apiPropuesta/GetEstadosPropuesta',
        model
      ).map(
        (respuesta: Response) => respuesta.json());
  }

  crearEstadoPropuesta(model: any, flujo_id: any): Observable<any> {
    return this.http
      .post(
        this.general.webserver + 'apiPropuesta/crearEstadoPropuesta',
        JSON.stringify({
          idCliente: localStorage.getItem('idCliente'),
          estado_propuesta: model,
          flujo_id: flujo_id
        })
      ).map(
        (respuesta: Response) => respuesta.json());
  }

  reOrdenarEstadosPropuesta(model: any): Observable<any> {
    return this.http
      .post(
        this.general.webserver + 'apiPropuesta/reOrdenarEstados',
        JSON.stringify({
          idCliente: localStorage.getItem('idCliente'),
          estados_propuesta: model
        })
      ).map(
        (respuesta: Response) => respuesta.json());
  }

  getEstadoPropuesta(idEstado: any): Observable<any> {
    return this.http
      .post(
        this.general.webserver + 'apiPropuesta/getEstadoPropuesta',
        JSON.stringify({
          idCliente: localStorage.getItem('idCliente'),
          idEstado: idEstado
        })
      ).map(
        (respuesta: Response) => respuesta.json());
  }

  eliminarEstadoPropuesta(idEstado: any): Observable<any> {
    return this.http
      .post(
        this.general.webserver + 'apiPropuesta/eliminarEstadoPropuesta',
        JSON.stringify({
          idCliente: localStorage.getItem('idCliente'),
          idEstado: idEstado
        })
      ).map(
        (respuesta: Response) => respuesta.json());
  }

  editarEstadoPropuesta(model: any): Observable<any> {
    return this.http
      .post(
        this.general.webserver + 'apiPropuesta/editarEstadoPropuesta',
        JSON.stringify({
          idCliente: localStorage.getItem('idCliente'),
          estado_propuesta: model
        })
      ).map(
        (respuesta: Response) => respuesta.json());
  }

  /*FIN ESTADOS */

  getTablas(): Observable<any> {
    let model = {};
    model['idCliente'] = localStorage.getItem('idCliente');
    return this.http
      .post(
        this.general.webserver + 'apiPropuesta/GetEstadosPropuesta',
        model
      ).map(
        (respuesta: Response) => respuesta.json());
  }

  generarPropuesta(model) {
    model["idCliente"] = localStorage.getItem("idCliente");
    return this.http
      .post(this.general.webserver + "apiPropuesta/guardar", model)
      .map((respuesta: Response) => respuesta.json());
  }
  getStatus(
    paginado: any = {
      page: 0,
      pageSize: 10,
    },
    orden: any = {
      sort: "",
      order: "",
    },
    filtros: any = {
      generico: "",
      tipo: "",
    }
  ): Observable<any> {
    return this.permisoService
      .getPermisoAction("GET-ESTADO-PROPUESTA")
      .switchMap((controllerAction) => {
        // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http.post(
          this.general.webserver + controllerAction,
          JSON.stringify({
            idCliente: localStorage.getItem("idCliente"),
            paginado: paginado,
            orden: orden,
            filtros: filtros,
          })
        );
      })
      .map(
        // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json()
      );
  }
  getPropuestas(
    paginado: any = {
      page: 0,
      pageSize: 10,
    },
    orden: any = {
      sort: "descripcion",
      order: "asc",
    },
    filtros: any = {
      generico: "",
      tipo: "",
    }
  ): Observable<any> {
    return this.permisoService
      .getPermisoAction("PANEL-PROPUESTAS")
      .switchMap((controllerAction) => {
        // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http.post(
          this.general.webserver + controllerAction,
          JSON.stringify({
            idCliente: localStorage.getItem("idCliente"),
            paginado: paginado,
            orden: orden,
            filtros: filtros,
          })
        );
      })
      .map(
        // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json()
      );
  }
  getArchivados(
    paginado: any = {
      page: 0,
      pageSize: 10,
    },
    orden: any = {
      sort: "descripcion",
      order: "asc",
    },
    filtros: any = {
      generico: "",
      tipo: "",
    }
  ): Observable<any> {
    return this.permisoService
      .getPermisoAction("VER-ARCHIVADOS")
      .switchMap((controllerAction) => {

        // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http.post(

          this.general.webserver + controllerAction,
          JSON.stringify({
            idCliente: localStorage.getItem("idCliente"),
            paginado: paginado,
            orden: orden,
            filtros: filtros,
          })
        );
      })
      .map(
        // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server}
        (respuesta: Response) => respuesta.json()

      );
  }
  archivarPropuesta(model): Observable<any> {
    model["idCliente"] = localStorage.getItem("idCliente");
    return this.permisoService
      .getPermisoAction("PROPUESTA-ARCHIVAR")
      .switchMap((controllerAction) => {
        // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http.post(this.general.webserver + controllerAction, model);
      })
      .map(
        // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json()
      );
  }

  desarchivarPropuesta(model): Observable<any> {
    model["idCliente"] = localStorage.getItem("idCliente");
    return this.http
      .post(this.general.webserver + "apiPropuesta/desarchivar", model)
      .map((respuesta: Response) => respuesta.json());
  }

  estadisticaEstadoPropuestas(model): Observable<any> {
    model["idCliente"] = localStorage.getItem("idCliente");
    return this.permisoService
      .getPermisoAction("ESTADISTICAS-ESTADO-PROSPECTO")
      .switchMap((controllerAction) => {
        // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http.post(this.general.webserver + controllerAction, model);
      })
      .map(
        // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json()
      );
  }
  estadisticaActividades(model): Observable<any> {
    model["idCliente"] = localStorage.getItem("idCliente");
    return this.permisoService
      .getPermisoAction("ESTADISTICAS-ACTIVIDADES")
      .switchMap((controllerAction) => {
        // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http.post(this.general.webserver + controllerAction, model);
      })
      .map(
        // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json()
      );
  }
  estadisticasPropuestas(model): Observable<any> {
    model["idCliente"] = localStorage.getItem("idCliente");
    return this.permisoService
      .getPermisoAction("ESTADISTICAS-PROPUESTAS")
      .switchMap((controllerAction) => {
        // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http.post(this.general.webserver + controllerAction, model);
      })
      .map(
        // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json()
      );
  }
  estadisticaCotizacion(model): Observable<any> {
    model["idCliente"] = localStorage.getItem("idCliente");
    return this.permisoService
      .getPermisoAction("ESTADISTICAS-COTIZACION")
      .switchMap((controllerAction) => {
        // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http.post(this.general.webserver + controllerAction, model);
      })
      .map(
        // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json()
      );
  }
  estadisticaSituacionPropuestas(model): Observable<any> {
    model["idCliente"] = localStorage.getItem("idCliente");
    return this.permisoService
      .getPermisoAction("ESTADISTICAS-SITUACION-PROSPECTO")
      .switchMap((controllerAction) => {
        // operando que espera a que termine el primer observable para iniciar el segundo

        return this.http.post(this.general.webserver + controllerAction, model);
      })
      .map(
        // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json()
      );
  }
  cambiarEstado(model): Observable<any> {
    return this.permisoService
      .getPermisoAction("PROPUESTA-CAMBIAR-ESTADO")
      .switchMap((controllerAction) => {
        // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http.post(this.general.webserver + controllerAction, model);
      })
      .map(
        // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json()
      );
  }
  subirArchivosPropuesta(
    propuesta_id: number | string,
    archivos: ArchivoPropuesta[]
  ): Observable<any> {
    return this.permisoService
      .getPermisoAction("PROPUESTA-ARCHIVO-GUARDAR")
      .switchMap((controllerAction) => {
        // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http.post(
          this.general.webserver + controllerAction,
          JSON.stringify({
            idCliente: localStorage.getItem("idCliente"),
            IdPropuesta: propuesta_id,
            archivos: archivos,
          })
        );
      })
      .map(
        // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json()
      );
  }
  getArchivoPropuesta(model): Observable<any> {
    model["idCliente"] = localStorage.getItem("idCliente");
    return this.permisoService
      .getPermisoAction("PROPUESTA-ARCHIVO-VER")
      .switchMap((controllerAction) => {
        // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http.post(this.general.webserver + controllerAction, model);
      })
      .map(
        // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json()
      );
  }
  eliminarArchivoPropuesta(model): Observable<any> {
    model["idCliente"] = localStorage.getItem("idCliente");
    return this.permisoService
      .getPermisoAction("PROPUESTA-ARCHIVO-ELIMINAR")
      .switchMap((controllerAction) => {
        // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http.post(this.general.webserver + controllerAction, model);
      })
      .map(
        // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json()
      );
  }
  getUrlZapier(): Observable<any> {
    return this.permisoService
      .getPermisoAction("PROPUESTA-GET-URL-ZAPIER")
      .switchMap((controllerAction) => {
        // operando que espera a que termine el primer observable para iniciar el segundo
        return this.http.post(
          this.general.webserver + controllerAction,
          JSON.stringify({
            idCliente: localStorage.getItem("idCliente"),
            webserver: this.general.webserver,
          })
        );
      })
      .map(
        // espera que terminen todos los operandos que haya para actuar sobre el dato final que llega del server
        (respuesta: Response) => respuesta.json()
      );
  }
}
